import { CreateChangePasswordSchema } from 'commons/passwordChange';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

// 多言語対応のためスキーマをフック化
export const useCreateChangePasswordSchema = () => {
  const { t } = useTranslationWithLang('auditionForm');

  const schema = CreateChangePasswordSchema({
    RequiredMessage: t('Validate_Required'),
    PasswordConfirmationMessage: t('Validate_PasswordConfirmation'),
    SpecialCharacterMessage: t('Validate_SpecialCharacter'),
    UppercaseMessage: t('Validate_Uppercase'),
    LowercaseMessage: t('Validate_Lowercase'),
    NoFullWidthMessage: t('Validate_NoFullWidth'),
    NumericMessage: t('Validate_Numeric'),
    MinLengthMessage: (min: number) => t('Validate_MinLength', { min }),
    MaxLengthMessage: (max: number) => t('Validate_MaxLength', { max }),
    LengthMessage: (length: number) => t('Validate_Length', { length }),
    PasswordNumericMessage: t('Validate_Password_Numeric'),
  });
  return schema;
};
